import React from 'react';
import { useCountUp } from 'react-countup';

function CountUp ({ end }) {
  const { countUp } = useCountUp({ start: 0, end })
  return <span>{countUp}</span>
}

export default CountUp;
